import { gql } from "lib/apolloClient";
import { studentsAlertFragment } from "modules/CommonFragments";
import { defaultOutcomeFragment } from "BehaviourManagement/modules/BehaviourManagementFragments";
import { incidentFragment, studentFragment } from "./IncidentFragments";

export const getIncidentDetailsQuery = gql`
  query getIncidentDetails($id: ID!, $includeUserCurriculums: Boolean!) {
    node(id: $id, type: BEHAVIOUR_INCIDENT) {
      ...incidentDetails
      ... on BehaviourIncident {
        id
        category {
          id
          defaultOutcomes {
            ...defaultOutcomeItem
          }
        }
      }
    }
  }
  ${incidentFragment.incidentDetailsFragment}
  ${defaultOutcomeFragment.defaultOutcome}
`;

export const getStudentListQuery = gql`
  query getStudentList(
    $first: Int
    $after: String
    $organizationId: ID!
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $studentFilters: OrgConnectionFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      ... on Organization {
        id
        students(
          first: $first
          after: $after
          orderBy: $orderBy
          orderByDirection: $orderByDirection
          filters: $studentFilters
        ) {
          totalCount
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              firstName
              middleName
              lastName
              profileImage
              middleName
              preferredName
              pronouns
              prefix
              suffix
              gender
              alertTypes {
                ...alertTypeFields
              }
              yearGroup {
                id
                curriculumProgram {
                  id
                }
                grade {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
  ${studentsAlertFragment}
`;

export const getStudentDetailsQuery = gql`
  query getStudentDetails(
    $id: ID!
    $staffRelationFilters: StaffStudentRelationFilter
    $relatedIncidentInput: RelatedIncidentsInput!
    $fetchRelatedIncidents: Boolean!
    $familiesFilter: FamiliesFiltersInput
    $behaviourOverviewInput: BehaviourOverviewInput
    $curriculumProgramsFilter: StudentCurriculumProgramFilter
  ) {
    node(id: $id, type: STUDENT) {
      id
      ... on Student {
        id
        type
        firstName
        middleName
        lastName
        preferredName
        pronouns
        prefix
        suffix
        profileImage
        yearGroup {
          id
          grade {
            id
            name
          }
        }
        alertTypes {
          ...alertTypeFields
        }
        ...studentHomeroomAdvisor
        ...studentFamilies
        curriculumPrograms(filters: $curriculumProgramsFilter) {
          id
        }
        behaviourOverview(input: $behaviourOverviewInput) {
          categoryWiseCount {
            category {
              id
              name
              color
              iconData
            }
            count
          }
          relatedIncidents(input: $relatedIncidentInput)
            @include(if: $fetchRelatedIncidents) {
            totalCount
            accessibleIncidentsCount
            incidents {
              id
              title
              incidentTime
              createdBy {
                id
                type
                firstName
                lastName
              }
              severity {
                id
                name
                color
              }
            }
          }
        }
      }
    }
  }
  ${studentsAlertFragment}
  ${studentFragment.studentFamiliesFragment}
  ${studentFragment.studentHomeroomAdvisorFragment}
`;

export const getActivityLogQuery = gql`
  query getActivityLog($id: ID!, $input: BehaviourIncidentActivityLogInput) {
    node(id: $id, type: BEHAVIOUR_INCIDENT) {
      id
      ... on BehaviourIncident {
        id
        activityLogV2(input: $input) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              type
              metadata
              entityData {
                ... on BehaviourIncident {
                  id
                  uid
                }
                ... on BehaviourLocation {
                  id
                  name
                }
                ... on BehaviourCategory {
                  id
                  name
                }
                ... on BehaviourSeverity {
                  id
                  name
                }
                ... on BehaviourAction {
                  id
                  title
                }
                ... on Staff {
                  id
                  firstName
                  middleName
                  lastName
                  preferredName
                  prefix
                  suffix
                  pronouns
                }
                ... on Student {
                  id
                  firstName
                  middleName
                  lastName
                  preferredName
                  pronouns
                  prefix
                  suffix
                }
              }
              createdAt
              createdBy {
                id
                firstName
                middleName
                lastName
                ... on Staff {
                  preferredName
                  prefix
                  suffix
                  pronouns
                }
              }
            }
          }
        }
      }
    }
  }
`;
